import { STATSIG_EXPERIMENTS } from '@src/config/statsig-experiments.config'
import { useStatsigExperimentBucket } from '@src/experiments/statsig-integration'

export default function useEddExp(): string | undefined {
  const experimentBucket = useStatsigExperimentBucket(STATSIG_EXPERIMENTS.EDD)

  return experimentBucket
}
